export const BonusRuleTypeEnum = {
  TotalWinning: 1,
  NetWinning: 2,
};

export const BonusRuleBasisEnum = {
  Profit: 1,
  Return: 2,
};
